import { fetchSimilarListings } from 'lib/AutolistAPI';
import { ListingViewModel } from 'components/Shared/ListingsCarousel/types';
import { transformSimilarListingsApiResponse } from 'lib/AutolistAPI/transformers';
import { useEffect, useState } from 'react';

export default function useSimilarListingsViewModels(vin: string): ListingViewModel[] {
  const [similarListings, setSimilarListings] = useState<any>([]);

  useEffect(() => {
    fetchSimilarListings(vin).then((data) => {
      setSimilarListings(transformSimilarListingsApiResponse(data));
    });
  }, [vin]);

  return similarListings;
}
